import { RiskLevel } from '@actschurch/ccms-sdk';

export const PROJECT_QUERY_KEYS = {
  all: ['projects'] as const,
  listView: ['projects', 'list-view'] as const,
  myListView: ['projects', 'my-list-view'] as const,
  view: (id: number) => ['projects', 'view', id] as const,
  milestones: ['project-milestones', 'all'] as const,
  milestonesForProject: (id: number) => ['project', id, 'milestones'] as const,
  milestoneTasks: (id: number) => ['project', id, 'milestone-tasks'] as const,
  risks: ['project-risks', 'all'] as const,
  risksForProject: (id: number) => ['project', id, 'risks'] as const,
  teamMembers: ['project-team-members', 'all'] as const,
  teamForProject: (id: number) => ['project', id, 'team'] as const,
  documents: (id: number) => ['project', id, 'documents'] as const,
  messages: (id: number) => ['project', id, 'messages'] as const,
  auditLog: (id: number) => ['project', id, 'audit-log'] as const,
  plannedBudget: (id: number) => ['project', id, 'planned-budget'] as const,
  budgetLines: (id: number) => ['project', id, 'budget-lines'] as const,
  timeLogs: (id: number) => ['project', id, 'time-logs'] as const,
  statuses: ['project-statuses'] as const,
  types: ['project-types'] as const,
  origins: ['project-origins'] as const,
  roles: ['project-roles'] as const,
  resourceTypes: ['resource-types'] as const,
} as const;

export const RISK_LEVEL_LABELS: Record<RiskLevel, string> = {
  [RiskLevel.Low]: 'Low',
  [RiskLevel.Medium]: 'Medium',
  [RiskLevel.High]: 'High',
  [RiskLevel.Critical]: 'Critical',
};

export const RISK_LEVEL_COLORS: Record<RiskLevel, string> = {
  [RiskLevel.Low]: 'green',
  [RiskLevel.Medium]: 'yellow',
  [RiskLevel.High]: 'orange',
  [RiskLevel.Critical]: 'red',
};

export const RISK_LEVEL_OPTIONS = [
  { value: String(RiskLevel.Low), label: 'Low' },
  { value: String(RiskLevel.Medium), label: 'Medium' },
  { value: String(RiskLevel.High), label: 'High' },
  { value: String(RiskLevel.Critical), label: 'Critical' },
];

export const HEALTH_STATUS_COLORS: Record<string, string> = {
  'On Track': 'green',
  'At Risk': 'yellow',
  Critical: 'red',
  Completed: 'teal',
};

export const HEALTH_STATUS_OPTIONS = [
  { value: 'On Track', label: 'On Track' },
  { value: 'At Risk', label: 'At Risk' },
  { value: 'Critical', label: 'Critical' },
  { value: 'Completed', label: 'Completed' },
];

/** Fallback colours keyed by the seeded ProjectStatus IDs, used when a status has no colour. */
export const DEFAULT_STATUS_COLORS: Record<number, string> = {
  [-2]: 'yellow', // On Hold
  [-1]: 'red', // Cancelled
  0: 'gray', // Planning
  1: 'blue', // In Progress
  2: 'green', // Completed
};
